import React, { useContext, useState, useEffect, useMemo, useRef } from 'react';
import Slider from 'react-slick';

import * as S from './BannerCarouselStyle';
import DisplayContext from 'UtilityComponents/displayContext';
import {
	Heading,
	GenericP,
	GenericDiv
} from 'commonStyles';
import { isMobileContext } from 'UtilityComponents/Util';
import Button from 'common/Button/Button';

const BannerCarousel = ({ toggleForm, config = {} }) => {
	const { bannerCarouselData, QUERY_BTN_TXT, SideBannerUrl, imgUrl, bg } = config;
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	const [sliderSetiings, setSliderSettings] = useState({
		infinite: false,
		autoplay: false
	});
	const sliderRef = useRef();

	const { mainHeading, sliderData = [] } = bannerCarouselData;

	useEffect(()=>{
		setTimeout(() => {
			setSliderSettings((state) => ({
				...state,
				infinite: true,
				autoplay: true
			}));
			sliderRef && sliderRef.current && sliderRef.current.slickPlay();
		}, [1000]);
	}, []);

	const settings = useMemo(()=>({
		...sliderSetiings,
		dots: true,
		fade: true,
		arrows: false,
		speed: 1000,
		autoplaySpeed: 5000,
		slidesToShow: 1,
		slidesToScroll: 1,
		appendDots: (dots) => (
			<S.BannerDotsWrap
				style={{
					display: 'flex'
				}}>
				<ul style={{ margin: '0px' }}> {dots} </ul>
			</S.BannerDotsWrap>
		)
	}), [sliderSetiings]);

	return (
		<S.MainWrapper imgUrl={imgUrl}>
			<S.BannerWrapper>
				<S.HomepageBannerLeft width='49%'>
					<S.MainHeading
						f_weight='900'
						fsize={isMobile ? '12px' : '22px'}
						color='#ff664b'
						bottom_M='8'>
						{mainHeading}
					</S.MainHeading>
					<Slider {...settings} ref={sliderRef}>
						{sliderData.map((data, index) => {
							const { heading: carouselHeading, subHeading } = data;
							return (
								<div key={carouselHeading + subHeading}>
									<S.HomepageBannerContainer>
										<S.HeaderWrapper>
											<Heading
												className='appendTop16'
												fontSize={`${isMobile ? '32px' : '48px'}`}
												marBt={`${isMobile ? '16px' : '26px'}`}
												color='#fff'
												dangerouslySetInnerHTML={{ __html: carouselHeading }}
											/>
											<GenericP
												bottom_M={isMobile ? '18' : '22'}
												fsize={`${isMobile ? '20px' : '22px'}`}
												color='#fff'
												dangerouslySetInnerHTML={{ __html: subHeading }}
											/>
										</S.HeaderWrapper>
									</S.HomepageBannerContainer>
								</div>
							);
						})}
					</Slider>
					<GenericDiv position='relative' color='#fff'>
						Get in touch with us to give your employees and channel partners a delightful
						experience anywhere around the globe. Our dedicated point of contact will take care of
						end-to-end management of all your official group travel, offsites, events and conferences.
					</GenericDiv>
				</S.HomepageBannerLeft>
				<S.HomepageBannerRight>
					<S.SideContentWrap
						justify='center'
						align='center'
						direction='column'
						directionInMobile='column'
						top_P={SideBannerUrl ? '0' : '50'}
						bottom_P={SideBannerUrl ? '0' : '50'}
						right_P={SideBannerUrl ? '0' : '50'}
						left_P={SideBannerUrl ? '0' : '50'}
						bg={bg}
						bdrRad='6px'>
						{SideBannerUrl ?
							<img src={SideBannerUrl} /> :
							<>
								<GenericP
									text_align='center'
									color='rgb(74, 74, 74)'
									fsize={isMobile ? '20px' : '32px'}
									f_weight={400}
									line_height={isMobile ? '24px' : '34px'}
									bottom_M={isMobile ? 20 : 40}>
									Book all kind of Venues for your official event.
								</GenericP>
								<Button
									btnTxt={QUERY_BTN_TXT}
									btnType='Flat'
									btnName='Primary'
									btnShadow
									handleClick={toggleForm}
									btnWidth='80%'
									height='64px'
								/>
							</>}
					</S.SideContentWrap>
				</S.HomepageBannerRight>
			</S.BannerWrapper>
		</S.MainWrapper>
	);
};

export default (BannerCarousel);
